import { RcFile } from 'antd/lib/upload';
import * as pdfjs from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import { MIMEType } from 'types/MIME-types';

export const pdfToImage = async (file: RcFile): Promise<Blob> => {
  const canvas = document.createElement('canvas');
  const pdfDocument = await pdfjs.getDocument(await file.arrayBuffer()).promise;
  const firstPage = await pdfDocument.getPage(1);

  const viewport = firstPage.getViewport({ scale: 1 });
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw Error('Could not obtain canvas context');
  }

  canvas.height = viewport.height;
  canvas.width = viewport.width;

  await firstPage.render({
    canvasContext: ctx,
    viewport,
  }).promise;

  const base64ImageData = canvas.toDataURL(MIMEType.IMAGE_PNG);
  const base64Data = base64ImageData.split(',')[1];

  if (!base64Data) {
    throw Error('Could not obtain image base64 data');
  }

  const binaryBlobData = atob(base64Data);
  const dataArray = [];

  for (let i = 0; i < binaryBlobData.length; i++) {
    dataArray.push(binaryBlobData.charCodeAt(i));
  }

  return new Blob([new Uint8Array(dataArray)], {
    type: MIMEType.IMAGE_PNG,
  });
};
